<template>
  <button
    v-if="!url"
    :type="type"
    :aria-label="text"
    :disabled="isDisabled"
    class="relative cursor-pointer self-start rounded-[40px] border-2 font-bold transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-accent-brand focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-30"
    :class="[sizeClasses[size ?? 'default'], variantClasses[variant][darkmode ? 'dark' : 'light']]"
    @click="emit('click')"
  >
    <span v-if="isLoading" class="absolute inset-0 flex items-center justify-center">
      <BaseIcon icon="LoaderCircle" class="animate-spin" />
    </span>

    {{ text }}
  </button>

  <a
    v-if="url"
    :href="url"
    :target="target"
    rel="noopener noreferrer"
    class="relative block cursor-pointer self-start rounded-[40px] border-2 font-bold no-underline transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-accent-brand focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-30"
    :class="[sizeClasses[size ?? 'default'], variantClasses[variant][darkmode ? 'dark' : 'light']]"
  >
    <span v-if="isLoading" class="absolute inset-0 flex items-center justify-center">
      <BaseIcon icon="LoaderCircle" class="animate-spin" />
    </span>

    {{ text }}
  </a>
</template>

<script setup lang="ts">
import type { IBaseButton } from '@/common/components/base/BaseButton/IBaseButton'
import BaseIcon from '@/common/components/base/BaseIcon/BaseIcon.vue'

withDefaults(defineProps<IBaseButton>(), {
  isLoading: false,
  isDisabled: false,
  size: 'default',
  variant: 'primary',
  type: 'button',
  darkmode: false,
})

const emit = defineEmits<{
  (e: 'click'): void
}>()

const sizeClasses = {
  small: 'px-[0.875rem] py-[0.375rem] text-button-sm',
  default: 'px-6 py-2 text-button',
}

const variantClasses = {
  primary: {
    light:
      'bg-accent-brand border-accent-brand text-text-light hover:text-text-light hover:bg-background-blue hover:border-background-blue',
    dark: 'bg-white border-white text-text-dark hover:bg-accent-03 hover:border-accent-03',
  },
  secondary: {
    light:
      'border-brand-02 bg-transparent text-text-dark hover:bg-background-blue hover:text-text-light hover:border-background-blue',
    dark: 'border-white bg-transparent text-text-light hover:border-accent-03 hover:bg-accent-03 hover:text-text-dark',
  },
}
</script>
